import Dropdown from 'bootstrap/js/dist/dropdown';
import {initMap} from './MapBlock/MapBlock';
import Collapse from 'bootstrap/js/dist/collapse';
import Modal from 'bootstrap/js/dist/modal';
import CasesBlock from './blocks/cases';
import EmployeesBlock from "./blocks/employees";
import NewsBlock from "./blocks/news";


//
window.addEventListener("load", (event) => {
    try {
        /**
         * Dropdowns
         */
        const dropdownElementList = document.querySelectorAll('.dropdown-toggle')
        // @ts-ignore
        const dropdownList = [...dropdownElementList].map(dropdownToggleEl => new Dropdown(dropdownToggleEl))

        /**
         * Collapsables
         */
        const collapsables = [].slice.call(document.querySelectorAll('.collapse'));

        const collapseList = collapsables.map(function (collapseEl: HTMLElement) {
            const collapseInstance: Collapse = new Collapse(collapseEl, {toggle: false});

            if (collapseEl.classList.contains('navbar-collapse')) {
                collapseEl.addEventListener('show.bs.collapse', toggleNavbarExpandedToHeader)
                collapseEl.addEventListener('hide.bs.collapse', toggleNavbarExpandedToHeader)
            }

            return collapseInstance;
        })

        /**
         * Modals
         */

        const modals = [...document.querySelectorAll('.modal')].map((modalElem) => {
            return new Modal(modalElem);
        })

        /**
         * Make the caseblock instance global
         */
        const casesBlockExists = document.querySelector('.block-cases');

        if (casesBlockExists) {
            // @ts-ignore - window is tricky with typescript
            window.casesBlock = new CasesBlock(casesBlockExists as HTMLDivElement)
        }  
        
        /**
         * Make the caseblock instance global
         */
        const employeesBlockExist = document.querySelector('.employees-block');

        if (employeesBlockExist) {
            // @ts-ignore - window is tricky with typescript
            window.employeesBlock = new EmployeesBlock(employeesBlockExist as HTMLDivElement)
        }

        /**
         * find all month fields and convert them to date fields
         * Safari and Firefox specific in desktop
         */
        [...document.querySelectorAll('input[data-type="month"]')].map((item: HTMLInputElement) => {
            if (item.type === 'text') {
                item.type = 'date';
                item.max = new Date().toISOString().split('T')[0];
            }
        })

        /**
         * Make the employeeBlock instance global
         */
        const newsBlockOnPage = document.querySelector('.block-news');

        if (newsBlockOnPage) {
            // @ts-ignore - window is tricky with typescript
            window.newsBlock = new NewsBlock(newsBlockOnPage as HTMLDivElement)
        }

    } catch (e) {
        console.error(e);
    }

    //check if a map block is present on the page
    const mapBlockOnPage = document.querySelector('.map__canvas');

    if (mapBlockOnPage) {
        //run map function.
        initMap();
    }
});

/**
 * @see VideoBlock.cshtml
 * @todo move to block folder?
 */
// @ts-ignore - window is tricky with typescript
window.playVideo = function (element: HTMLButtonElement) {
    try {
        if (element) {
            const videoContainer = element.parentElement.parentElement;

            if (videoContainer.tagName.toLowerCase() === 'figure') {
                const videoElement = videoContainer.querySelector('video');

                if (videoElement) {
                    videoContainer.classList.add('block-video--activated')
                    videoElement.controls = true;
                    videoElement.play();
                    return;
                }

                const vimeoIframe = videoContainer.querySelector('iframe');

                if (vimeoIframe) {
                    videoContainer.classList.add('block-video--activated')
                    /**
                     * If the iframe hasn't loaded yet. It does not work as intended. The iframe need to be 100% loaded.
                     * We will probably have issues if someone tries to start a video on slow connection. 
                     * But will work anyways because you can start the video using the embeded video anyways
                     * 
                     * @see https://github.com/vimeo/player.js for more documentation how to trigger play
                     */
                    vimeoIframe.contentWindow.postMessage({method: 'play'}, '*');
                    return;
                }
            }
        }
        throw 'Unable to start'
    } catch (e) {
        console.log(e);
    }
};

const toggleNavbarExpandedToHeader = (event: Event) => {
    const target = event.target as unknown as HTMLElement;

    if (target.classList.contains('navbar-collapse')) {

        const mainNavigation = document.querySelector('header.main-navigation'); // could be replaced by id but is pretty unique by itself

        switch (event.type) {
            case 'show.bs.collapse':
                mainNavigation.classList.add('main-navigation--expanded')
                break;
            case 'hide.bs.collapse':
                mainNavigation.classList.remove('main-navigation--expanded')
                break;
            default:
                return;
        }
    }
}